import { useState } from 'react'
import { Typography } from 'antd'
import { getCookie } from 'utils'
const { Text, Link } = Typography

export const PreviewBranchIndicator = () => {

    const [ previewBranch ] = useState(getCookie('preview-branch'))

    return previewBranch ? (
        <Text
            type='secondary'
            style={{
                maxWidth: 250,
                display: 'flex'
            }}
        >
            [
            <Text
                type='secondary'
                title={previewBranch}
                style={{
                    maxWidth: 180,
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden'
                }}
            >
                    {previewBranch}
            </Text>
            ]
            [
            <Link
                type='secondary'
                href={`${window.location.href}?preview-branch=reset`}
            >
                reset
            </Link>
            ]
        </Text>
    ) : <></>

}
